import script from "./ClipboardButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClipboardButton.vue?vue&type=script&setup=true&lang=ts"

import "./ClipboardButton.vue?vue&type=style&index=0&id=29596bc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29596bc6"]])

export default __exports__